
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class DiscountingPolicyDialog extends _Ext.DialogBase<DiscountingPolicyRow, any> {
        protected getFormKey() { return DiscountingPolicyForm.formKey; }
        protected getIdProperty() { return DiscountingPolicyRow.idProperty; }
        protected getLocalTextPrefix() { return DiscountingPolicyRow.localTextPrefix; }
        protected getNameProperty() { return DiscountingPolicyRow.nameProperty; }
        protected getService() { return DiscountingPolicyService.baseUrl; }
        protected getDeletePermission() { return DiscountingPolicyRow.deletePermission; }
        protected getInsertPermission() { return DiscountingPolicyRow.insertPermission; }
        protected getUpdatePermission() { return DiscountingPolicyRow.updatePermission; }

        protected form = new DiscountingPolicyForm(this.idPrefix);
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        constructor() {
            super();
            q.hideEditorLabel(this.form.Details)
        }
        protected validateBeforeSave() {
            var returnvalue = super.validateBeforeSave();
            var details = this.form.Details.getItems();
            var discount100 = false;
            for (var i = 0; i < details.length; i++) {
                var detail = details[i]; 
                if (detail.MaxDiscountPercent == 100) {
                    discount100 = true;
                }
            }

            if (!discount100) {
                q.alert('', 'One Discount Detail Should be 100%', true, 2999);
                returnvalue = false;
                return returnvalue;
            }
            return returnvalue;
        }
    }
}